var exports = {
  "kL": "x93eb46d8--a5fefd--container",
  "qC": "x93eb46d8--a5fefd--container_expanded",
  "p_": "x93eb46d8--a5fefd--list",
  "c5": "x93eb46d8--a5fefd--arrow-wrapper",
  "R_": "x93eb46d8--a5fefd--heading",
  "DD": "x93eb46d8--a5fefd--title",
  "nf": "x93eb46d8--a5fefd--link",
};

module.exports = exports;
